export default __webpack_public_path__ + "static/media/report-active.0ba4824d.svg";